<div id="boss-login-error" class="alert alert-error" style="margin-bottom: 24px;">
	<div class="alert-icons">
		<span class="icon-alert"></span>
	</div>
	<div class="alert-text">
		<h1 class="alert-h1">{{ 'boss-bossError-mensaje-error' | translate }}</h1>
		<p class="error" ng-transclude></p>
		<!--<p><a class="button-link" href="#">{{ 'boss-errormsg-saber-mas' | translate }}</a></p>-->
	</div>
</div>
